var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExpire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.536 20.834a2.5 2.5 0 00-5 0v18.333h-10.49c-1.38 0-2.5 1.117-2.5 2.5l.022.34a2.502 2.502 0 002.478 2.16h15.49V20.834zM6.666 40C6.667 21.59 21.59 6.667 40 6.667 58.41 6.667 73.333 21.59 73.333 40c0 2.99-.393 5.889-1.132 8.646a16.731 16.731 0 00-4.362-3.358c.324-1.714.494-3.481.494-5.288 0-15.623-12.71-28.333-28.333-28.333-15.623 0-28.333 12.71-28.333 28.333 0 15.623 12.71 28.333 28.333 28.333 1.807 0 3.574-.17 5.288-.494a16.73 16.73 0 003.358 4.362A33.379 33.379 0 0140 73.333C21.59 73.333 6.667 58.41 6.667 40z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.667 60c0-7.364 5.969-13.333 13.333-13.333S73.333 52.636 73.333 60 67.364 73.333 60 73.333 46.667 67.364 46.667 60zm8.619 4.714a1 1 0 010-1.414l3.3-3.3-3.3-3.3a1 1 0 011.414-1.414l3.3 3.3 3.3-3.3a1 1 0 011.414 1.414l-3.3 3.3 3.3 3.3a1 1 0 11-1.414 1.414l-3.3-3.3-3.3 3.3a1 1 0 01-1.414 0z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpire);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconExpire.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };